module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Texts</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Text\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"text\" name=\"textColor\" type=\"color\" value=\"")
    ; __append(escapeFn( textColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"textColor\" name=\"textColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( textColor ))
    ; __append("\" />\r\n\r\n            <select name=\"textFont\" class=\"style-font\"  id=\"textFont\" data-key=\"control_text\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"textFontSize\" id=\"textFontSize\" class=\"style-font-size\" data-key=\"control_text\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"textBold\" class=\"weightSelectorText\" name=\"textWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( textWeightSelection ))
    ; __append("\" />\r\n            <img id=\"textItalic\" class=\"styleSelectorText\" name=\"textStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( textStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Small Text\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"smallText\" name=\"smallTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( smallTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"smallTextColor\" name=\"smallTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( smallTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"smallTextFont\" class=\"style-font\"  id=\"smallTextFont\" data-key=\"control_small_text\">\r\n            \r\n            </select>\r\n\r\n            <select name=\"smallTextFontSize\" id=\"smallTextFontSize\" class=\"style-font-size\" data-key=\"control_small_text\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"smallTextBold\" class=\"weightSelectorText\" name=\"smallTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( smallTextWeightSelection ))
    ; __append("\" />\r\n            <img id=\"smallTextItalic\" class=\"styleSelectorText\" name=\"smallTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( smallTextStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Large Heading\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"largeHeading\" name=\"largeHeadingColor\" type=\"color\" value=\"")
    ; __append(escapeFn( largeHeadingColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"largeHeadingColor\" name=\"largeHeadingColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( largeHeadingColor ))
    ; __append("\" />\r\n\r\n            <select name=\"largeHeadingFont\" class=\"style-font\"  id=\"largeHeadingFont\" data-key=\"control_large_heading\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"largeHeadingFontSize\" id=\"largeHeadingFontSize\" class=\"style-font-size\" data-key=\"control_large_heading\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"largeHeadingBold\" class=\"weightSelectorText\" name=\"largeHeadingWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( largeHeadingWeightSelection ))
    ; __append("\" />\r\n            <img id=\"largeHeadingItalic\" class=\"styleSelectorText\" name=\"largeHeadingStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( largeHeadingStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Medium Heading\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"mediumHeading\" name=\"mediumHeadingColor\" type=\"color\" value=\"")
    ; __append(escapeFn( mediumHeadingColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"mediumHeadingColor\" name=\"mediumHeadingColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( mediumHeadingColor ))
    ; __append("\" />\r\n\r\n            <select name=\"mediumHeadingFont\" class=\"style-font\"  id=\"mediumHeadingFont\" data-key=\"control_medium_heading\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"mediumHeadingFontSize\" id=\"mediumHeadingFontSize\" class=\"style-font-size\" data-key=\"control_medium_heading\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"mediumHeadingBold\" class=\"weightSelectorText\" name=\"mediumHeadingWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( mediumHeadingWeightSelection ))
    ; __append("\" />\r\n            <img id=\"mediumHeadingItalic\" class=\"styleSelectorText\" name=\"mediumHeadingStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( mediumHeadingStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Small Heading\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"smallHeading\" name=\"smallHeadingColor\" type=\"color\" value=\"")
    ; __append(escapeFn( smallHeadingColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"smallHeadingColor\" name=\"smallHeadingColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( smallHeadingColor ))
    ; __append("\" />\r\n\r\n            <select name=\"smallHeadingFont\" class=\"style-font\"  id=\"smallHeadingFont\" data-key=\"control_small_heading\">\r\n             \r\n            </select>\r\n\r\n            <select name=\"smallHeadingFontSize\" id=\"smallHeadingFontSize\" class=\"style-font-size\" data-key=\"control_small_heading\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"smallHeadingBold\" class=\"weightSelectorText\" name=\"smallHeadingWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( smallHeadingWeightSelection ))
    ; __append("\" />\r\n            <img id=\"smallHeadingItalic\" class=\"styleSelectorText\" name=\"smallHeadingStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( smallHeadingStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Link\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"link\" name=\"linkColor\" type=\"color\" value=\"")
    ; __append(escapeFn( linkColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"linkColor\" name=\"linkColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( linkColor ))
    ; __append("\" />\r\n\r\n            <select name=\"linkFont\" class=\"style-font\"  id=\"linkFont\" data-key=\"control_link\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"linkFontSize\" id=\"linkFontSize\" class=\"style-font-size\" data-key=\"control_link\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"linkBold\" class=\"weightSelectorText\" name=\"linkWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( linkWeightSelection ))
    ; __append("\" />\r\n            <img id=\"linkItalic\" class=\"styleSelectorText\" name=\"linkStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( linkStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}